<template>
	<div class="shopping-list-wrapper" data-tour-item="shoppingList">
		<button :class="{ active: isActive }" v-if="enabled" class="btn has-tooltip"
			v-tooltip="{ content: content.shoppingListToolTip, classes: 'last' }" :aria-label="content.shoppingListToolTip"
			v-bind="config.attrs" @click="toggle">
			<svg role="img" width="25px" height="22px" viewBox="5 10 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink" aria-labelledby="shoppingList">
				<title id="shoppingList">Shopping List</title>
				<g id="-Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="icon---English" transform="translate(-1868.000000, -22.000000)">
						<g id="icon---list" transform="translate(1868.000000, 23.000000)">
							<g class="line-fill" id="Group" transform="translate(7.000000, 9.000000)">
								<rect id="Rectangle-Copy-34" x="6" y="0" width="14" height="3" rx="1.5"></rect>
								<rect id="Rectangle-Copy-37" x="0" y="0" width="3" height="3" rx="1.5"></rect>
								<rect id="Rectangle-Copy-35" x="6" y="7" width="14" height="3" rx="1.5"></rect>
								<rect id="Rectangle-Copy-38" x="0" y="7" width="3" height="3" rx="1.5"></rect>
								<rect id="Rectangle-Copy-36" x="6" y="14" width="14" height="3" rx="1.5"></rect>
								<rect id="Rectangle-Copy-39" x="0" y="14" width="3" height="3" rx="1.5"></rect>
							</g>
						</g>
					</g>
				</g>
			</svg>
			<span class="panel-label">{{ content.shoppingList.shoppingListDesc }}</span>

			<div v-if="count" class="count-badge">{{ count }}</div>


		</button>
		<span class="separator-right"></span>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "ShoppingListToggleButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'shoppingList'
		}
	},
	computed: {
		...mapGetters('config', ['features']),
		...mapState('shoppingList', ['showShoppingList', 'showShoppingListV1', 'showShoppingListV2','shoppingList', 'shoppingListV1','shoppingListV2']),
		...mapGetters('shoppingList', ['getVersion']),
		count() {
      const v = this.getVersion;
      if(v==='v1') return this.shoppingListV1.length
      else if(v==='v2') return this.shoppingListV2.length
      else return this.shoppingList.length
		},
		isActive() {
      const v = this.getVersion;
      if(v==='v1') return this.showShoppingListV1
      else if(v==='v2') return this.showShoppingListV2
      else return this.showShoppingList
		}
	},
	methods: {
    ...mapActions('shoppingList', ['toggleShoppingList','toggleShoppingListV1','toggleShoppingListV2']),
		toggle() {
      const v = this.getVersion;
      if(v==='v1') return this.toggleShoppingListV1(!this.showShoppingListV1)
      else if(v==='v2') return this.toggleShoppingListV2(!this.showShoppingListV2)
      else return this.toggleShoppingList(!this.showShoppingList);
		}
	}
}
</script>

<style lang="scss" scoped>
.shopping-list-wrapper {
	display: inline-flex;


	button {
		padding: 0;
		background: none;

		&.active {
			background: none !important;

		}

		&:hover {
			svg {
				.line-fill {
					fill: var(--secondary-color);
				}
			}

		}

		svg {
			.line-fill {
				fill: #545454;
			}
		}

		.panel-label {
			margin-top: 4px;
		}

	}

}


.btn {
	position: relative;
}

.count-badge {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	background-color: red;
	top: -0.3em;
	right: -0.5em;
	border-radius: 50%;
	height: 1.8em;
	min-width: 1.8em;
	font-size: 0.8em;
	color: #fff;
}

[mode='tablet'],
[mode='mobile'] {
	.shopping-list-wrapper {
		button {
			margin-left: 10px;
			padding: 0;

			.count-badge {
				top: -1em;
				right: -0.9em;
			}
		}
	}
}
</style>
